import React from 'react'
import { useCoinData } from '@components/TradingChart/useCoinData'
import { Box } from '@ui'
import { BigNumber } from 'ethers'
import { TOWNS_TOKEN_ADDRESS } from 'utils/isOfficialTownsToken'
import { formatEther, parseEther } from 'viem'

type Props = {
    value: bigint | string | number | BigNumber
    currency?: 'native' | 'usd'
    noDecimals?: boolean
    compact?: boolean
}

export const $TOWNS = (props: Props) => {
    const { currency = 'towns', noDecimals } = props
    const { data: coinData, isError } = useCoinData({
        address: TOWNS_TOKEN_ADDRESS,
        chain: '8453',
        disabled: currency !== 'usd',
    })

    let value = 0n
    try {
        if (typeof props.value === 'number' || typeof props.value === 'string') {
            value = parseEther(props.value.toString())
        } else if (props.value instanceof BigNumber) {
            value = props.value.toBigInt()
        } else {
            value = BigInt(props.value)
        }
    } catch (error) {
        console.error('Error parsing $TOWNS value', props.value, error?.toString())
        return <>N/A</>
    }

    if (currency === 'usd' && isError) {
        return (
            <Box tooltip="Error fetching $TOWNS price" color="error">
                <>$0.xx</>
            </Box>
        )
    }

    if (currency === 'usd' && coinData?.priceUSD) {
        const tokensAmount = Number(formatEther(value))
        const pricePerToken = Number(coinData.priceUSD)
        const usdValue = tokensAmount * pricePerToken
        return <>{formatUSD.format(usdValue)}</>
    }

    const valueAsString = formatEther(value)
    const valueAsNumber = noDecimals ? Math.round(Number(valueAsString)) : Number(valueAsString)

    return (
        <>
            {props.compact
                ? formatNativeCompact.format(valueAsNumber)
                : formatNative.format(valueAsNumber)}{' '}
            $TOWNS
        </>
    )
}

const formatUSD = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

const formatNative = Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 2,
})
const formatNativeCompact = Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 0,
    compactDisplay: 'short',
    notation: 'compact',
})
